"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const initialData_1 = __importDefault(require("./initialData"));
const mapper_1 = require("./mapper");
const onHandleChange_1 = require("./onHandleChange");
const schema_1 = __importDefault(require("./schema"));
const uiSchema_1 = __importDefault(require("./uiSchema"));
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const rocTemplate = {
    formToPayloadDataHandler: formToPayloadDataHandler_1.rocFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.rocPayloadToFormDataHandler,
    initialData: initialData_1.default,
    schema: schema_1.default,
    templateMapper: mapper_1.templateMapper,
    onHandleChange: onHandleChange_1.onHandleChange,
    onHandleChangeDependencies: onHandleChange_1.onHandleChangeDependencies,
    uiSchema: uiSchema_1.default,
};
exports.default = rocTemplate;
